/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { FormSelect } from '../../../../../components/tables/filterForms/FormSelect';
import { useGetAllChildrenQuery } from '../../../../../services/endpoints/people/child';
import { allergyOptions, allergySeverityOptions } from '../../../../../utils/consts';
import { StepProps } from './AddEditAllergy';

export const AllergyForm = ({ touched, errors, readOnly }: StepProps) => {
  const {
    data: children,
    error: childrenError
  } = useGetAllChildrenQuery({ data: { orderBy: { field: 'first_name', order: 'asc' } } });

  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader
            title="Allergy Details"
            showRequiredLegend={!readOnly}
          />
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="child_id"
          >
            <Field
              as={FormSelect}
              name="child_id"
              label="Child"
              options={children?.results?.map((g) => ({ value: g.id, label: g.full_name })) ?? []}
              required
              loadingError={
                childrenError
                  ? 'Error loading children'
                  : !!errors.child_id
                    ? 'Child selection is required'
                    : undefined
              }
            />
            <ErrorMessage name="child_id.value">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="allergy"
          >
            <FormLabel required>Allergy</FormLabel>
            <Field
              name="allergy"
              as={Form.Select}
              placeholder="Select"
              isInvalid={touched.allergy && !!errors.allergy}
              aria-required
            >
              <option>Select</option>
              {allergyOptions.map((allergy) => (
                <option
                  value={allergy}
                  key={allergy}
                >
                  {allergy}
                </option>
              ))}
            </Field>
            <ErrorMessage name="allergy">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="severity"
          >
            <FormLabel>Severity</FormLabel>
            <Field
              name="severity"
              as={Form.Select}
              placeholder="Select"
              isInvalid={touched.severity && !!errors.severity}
            >
              <option>Select</option>
              {allergySeverityOptions.map((opt) => (
                <option
                  value={opt}
                  key={opt}
                >
                  {opt}
                </option>
              ))}
            </Field>
            <ErrorMessage name="severity">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="details"
          >
            <FormLabel>Details</FormLabel>
            <Field
              name="details"
              as="textarea"
              className={`form-control ${touched.details && !!errors.details ? 'is-invalid' : ''}`}
              rows={4}
            />
            <ErrorMessage name="details">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
